import axios from 'axios';
import cfac22 from '../cfac22';

export const getOrgByID = async (orgId) => {
  try {
    const endpoint = `${cfac22('API_HOST_V2')}/organizations/id`;
    const response = await axios.get(endpoint, {
        params: { orgId },
        headers: {
          'Full-Url': window.location.href,
        },
        withCredentials: true,
      });
    return response.data;
  } catch (error) {
    throw error?.response || error;
  }
};

